(() => {
'use strict';
const purplePage = document.querySelector('#water3f-purple-page');
const expressionEyes = purplePage.querySelector('#expression-eyes');
const expressionMouth = purplePage.querySelector('#expression-mouth');
const expressionStatus = purplePage.querySelector('#expression-status');
const smiles = 'M11 13h4v-4h4v4h4v4h-4v-4h-4v4h-4zm26 0h4v-4h4v4h4v4h-4v-4h-4v4h-4z';
const kiss = 'M29 24h4v4h-4v4h4v4h-4v-4h-4v-4h4z';
const expressions = {
  idle: { eyes: 'M11 13h12v4H11zm26 0h12v4H37z', mouth: kiss, label: '閒置表情：已接上電源，尚未連接裝置' },
  fast: { eyes: smiles, mouth: kiss, label: '快充表情：正在快速充電' },
  full: { eyes: smiles, mouth: '', label: '笑眼表情：慢速充電或已充滿電力' }
};
purplePage.querySelectorAll('[data-expression]').forEach(button => {
  button.addEventListener('click', () => {
    const expression = expressions[button.dataset.expression];
    expressionEyes.setAttribute('d', expression.eyes);
    expressionMouth.setAttribute('d', expression.mouth);
    expressionStatus.textContent = expression.label;
    purplePage.querySelectorAll('[data-expression]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  });
});

const quantity = purplePage.querySelector('#quantity');
const decrease = purplePage.querySelector('[data-quantity="-1"]');
function normalizeQuantity() {
  const value = Number(quantity.value);
  const valid = Number.isSafeInteger(value) && value >= 1;
  quantity.setCustomValidity(valid ? '' : '請輸入 1 以上的整數');
  decrease.disabled = !valid || value <= 1;
  return valid;
}
purplePage.querySelectorAll('[data-quantity]').forEach(button => {
  button.addEventListener('click', () => {
    const value = Number(quantity.value);
    const current = Number.isSafeInteger(value) && value >= 1 ? value : 1;
    quantity.value = Math.max(1, current + Number(button.dataset.quantity));
    normalizeQuantity();
  });
});
quantity.addEventListener('input', normalizeQuantity);
purplePage.querySelector('.purchase-form').addEventListener('submit', event => {
  if (!normalizeQuantity()) {
    event.preventDefault();
    quantity.reportValidity();
  }
});
normalizeQuantity();

})();
